import(/* webpackMode: "eager" */ "/vercel/path0/src/app/cloud-solutions/microsoft-365/page.tsx");
